/**
 * Client-side error reporter — ยิง error/feedback ฝั่ง web ไป POST /api/client-log (best-effort)
 * ใช้ raw fetch (ไม่ผ่าน axios instance) กัน interceptor วน + กัน error ซ้อน error
 * ทุกอย่าง try/catch — logger ต้องไม่ทำให้แอปพัง
 */
import api from "./api";

function getBaseURL() {
  try {
    return (api && api.defaults && api.defaults.baseURL) || process.env.REACT_APP_BASE_API || "";
  } catch (e) {
    return process.env.REACT_APP_BASE_API || "";
  }
}

function getUser() {
  try {
    return {
      userId: localStorage.getItem("EmpId") || "",
      userName: localStorage.getItem("userName") || "",
    };
  } catch (e) {
    return { userId: "", userName: "" };
  }
}

/** ส่ง log 1 event ไป backend (fire-and-forget) */
export function reportClientError(payload) {
  try {
    const base = getBaseURL();
    if (!base) return;
    const body = Object.assign(
      { source: "web", level: "error", userAgent: (typeof navigator !== "undefined" && navigator.userAgent) || "" },
      getUser(),
      payload || {}
    );
    fetch(base.replace(/\/+$/, "") + "/api/client-log", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
      keepalive: true, // ให้ส่งได้แม้หน้ากำลัง unload/crash
    }).catch(function () {});
  } catch (e) {
    /* logger must never throw */
  }
}

/** ผู้ใช้ส่ง feedback (เผื่ออยากผูกปุ่ม feedback ในอนาคต) */
export function reportFeedback(message, meta) {
  reportClientError({ level: "feedback", message: message, url: window.location.href, meta: meta });
}

/** ดัก error ระดับ window: uncaught error + unhandled promise rejection */
export function installGlobalErrorHandlers() {
  try {
    if (typeof window === "undefined" || window.__clientLogInstalled) return;
    window.__clientLogInstalled = true;

    window.addEventListener("error", function (event) {
      reportClientError({
        level: "error",
        message: (event && event.message) || "window.error",
        url: window.location.href,
        stack: event && event.error && event.error.stack ? String(event.error.stack) : undefined,
        meta: {
          kind: "window.error",
          filename: event && event.filename,
          lineno: event && event.lineno,
          colno: event && event.colno,
        },
      });
    });

    window.addEventListener("unhandledrejection", function (event) {
      const reason = event && event.reason;
      reportClientError({
        level: "error",
        message: reason && reason.message ? reason.message : "unhandledrejection",
        url: window.location.href,
        stack: reason && reason.stack ? String(reason.stack) : undefined,
        meta: { kind: "unhandledrejection" },
      });
    });
  } catch (e) {
    /* noop */
  }
}
